import {Component, OnInit} from "@angular/core";

import {Router} from "@angular/router";
@Component({
    template:
        `
    <div class="notification">
    <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScUPdwWG50gsXdfILfUOIuFhcYqCyfg-szdztsyMBgBbULNng/viewform?embedded=true" width="760" height="500" frameborder="0" marginheight="0" marginwidth="0">載入中…</iframe>
    </div>
    `
})

export class NotificationComponent{


}



// WEBPACK FOOTER //
// ./src/app/notification.component.ts